import React, { useState } from 'react'
import classes from './Accordion.module.scss';

const Accordion = ({ heading, title, content }) => {
    const [openDrawer, setOpenDrawer] = useState(false);

    const handleClick = () => {
        setOpenDrawer(!openDrawer);
    }
    return (
        <div className={classes.Accordion}>
            <div className={openDrawer ? classes.Title_Active : classes.Title_Inactive} onClick={handleClick}>
                <h2>
                    {heading}
                </h2>
                <h2 >
                    {openDrawer ? "-" : "+"}
                </h2>
            </div>
            {openDrawer && (
                <div className={classes.Content}>
                    <h3>{title}</h3>
                    <br />
                    {typeof content === 'string' ? (
                        <p>{content}</p>
                    ) : (
                        Object.values(content).map((paragraph, index) => (
                            <>
                                <p key={index}>{paragraph} </p>
                                <br />
                            </>
                        ))
                    )}
                </div>
            )}

        </div>
    )
}

export default Accordion